import { shipmentAffValidate } from "../../application/dtos/shipment_aff_validate";

export class ShipmentAffEntity {
    constructor({id, unique_order_number, total, date, client}){
        this.id = id;
        this.unique_order_number = unique_order_number;
        this.total = total;
        this.date = date;
        this.client = client;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return shipmentAffValidate(this);
    }
}